export enum REGISTRATION_STEPS {
  create = 'create',
  payment = 'payment',
  terms = 'terms',
  congrats = 'congrats',
}
